import { useContext } from 'react';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import InteractionType from './InteractionType.jsx';
import { action, quiz, survey, questionAnswer } from './interactionTypeOptions';
import { InteractionContext } from '../../contexts';

import TileText from './components/TileText.jsx';
import Hr from '../../../Hr';
import Text from '../../../Text';
import InteractionItemSelected from './InteractionItemSelected.jsx';

import { ACTION, QUIZ, SURVEY, QA } from '../../utils/constants';

const Interaction = () => {
  const {
    values,
    handleQuestionSubTypeOnChange,
    handleQuestionOnChange,
  } = useContext(InteractionContext);
  const surveyOptions = values.dependentBoardEnabled
    ? survey.options
    : survey.options.slice(0, -1);

  return (
    <>
      <Hr />
      <InteractionContainer>
        <InteractionType
          id={ACTION}
          text={action.title}
          options={action.options}
        />
        <InteractionType id={QUIZ} text={quiz.title} options={quiz.options} />
        <InteractionType
          id={SURVEY}
          text={survey.title}
          options={surveyOptions}
        />
        <QnA
          as="button"
          variant="body1"
          isSelected={values.questionType === QA}
          onClick={e => {
            e.preventDefault();
            handleQuestionSubTypeOnChange(QA, '');
          }}
        >
          {questionAnswer.title}
        </QnA>
      </InteractionContainer>
      <Hr />
      <TileText
        tileText={values.question}
        onChangeTileText={handleQuestionOnChange}
      />
      <InteractionItemSelected
        type={values.questionType}
        option={values.questionSubtype}
      />
    </>
  );
};

export default Interaction;

const QnA = styled(Text)`
  border-radius: 0 8px 8px 0;
  width: 100%;
  text-align: center;
  border: 1px solid ${themeGet('colors.black.10')};
  background-color: ${({ isSelected }) =>
    isSelected ? themeGet('colors.primary.100') : themeGet('colors.white')};
  list-style: none;
  width: 100%;
  padding-right: 20px;
  color: ${({ isSelected }) =>
    isSelected ? themeGet('colors.white') : themeGet('colors.black.80')};
  display: inline-block;
  box-shadow: 0 1px 0 rgb(255 255 255 / 50%) inset;
  transition: background-color 300ms ease-out;
  padding-top: 0.8125em;
  padding-bottom: 0.75em;
  -webkit-appearance: none;
  cursor: pointer;
  position: relative;
  text-decoration: none;
  text-align: center;
  padding-left: 1.5em;
  text-transform: none;
  margin: 0;

  &:hover,
  &:focus {
    color: ${({ isSelected }) =>
      isSelected ? themeGet('colors.white') : themeGet('colors.black.60')};
    background-color: ${({ isSelected }) =>
      isSelected ? themeGet('colors.primary.100') : themeGet('colors.white')};
  }
`;

const InteractionContainer = styled.div`
  line-height: 1.125em;
  overflow: auto;
  margin-top: 23px;
  background-color: ${themeGet('colors.white')};
  display: flex;
  justify-content: center;
  padding: 0 0 24px;
  list-style: none;
`;
